import * as React from 'react';
import { PillButton } from 'smoothie';

interface AddInstitutionLinkButtonProps {
    onPress: () => void;
}

const AddInstitutionLinkButton = ({
    onPress,
}: AddInstitutionLinkButtonProps) => {
    return <PillButton onPress={onPress} text="Add" />;
};

export default AddInstitutionLinkButton;
